<footer class="app-footer bg-black text-white border-top mt-5">
  <div class="footer-main py-5">
    <div class="container">
      <div class="row">
        <!-- Brand Section -->
        <div class="col-lg-4 col-md-6 mb-4 mb-lg-0 text-center text-md-start">
          <div class="footer-brand">
            <a routerLink="/" class="brand-logo d-flex align-items-center justify-content-center justify-content-md-start text-decoration-none text-white fs-4 fw-bold transition-all">
              <img src="/logo-reverse.svg" alt="DOPT" class="logo-img">
            </a>
            <p class="footer-description text-white small mt-3 mb-0">
              Educazione finanziaria, strumenti operativi e consulenza indipendente.
              Tutto in un'unica piattaforma.
            </p>
          </div>
        </div>

        <!-- Quick Links -->
        <div class="col-lg-4 col-md-6 mb-4 mb-lg-0 text-center text-md-start">
          <div class="footer-section">
            <h5 class="footer-title fs-6 fw-bold text-white mb-4 position-relative pb-2">Link Rapidi</h5>
            <ul class="list-unstyled m-0 p-0">
              <li *ngFor="let link of quickLinks" class="mb-2">
                <a [routerLink]="link.route" [fragment]="link.fragment" class="text-decoration-none text-white small fw-medium d-inline-flex align-items-center transition-all">
                  <i class="fas fa-chevron-right me-2 small"></i>
                  {{ link.label }}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <!-- Social & Contact -->
        <div class="col-lg-4 col-md-12 text-center text-md-start">
          <div class="footer-section">
            <h5 class="footer-title fs-6 fw-bold text-white mb-4 position-relative pb-2">Contatti</h5>
            <div class="contact-info">
              <a href="mailto:info@doptfinanza.com" class="text-decoration-none text-white small mb-2 d-flex align-items-center justify-content-center justify-content-md-start transition-all">
                <i class="fas fa-envelope me-2 text-primary-pink"></i>
                info&#64;doptfinanza.com
              </a>
              <a href="https://www.google.com/maps/search/?api=1&query=Milano,+Via+Mauro+Macchi+8,+20123" target="_blank" rel="noopener noreferrer" class="text-decoration-none text-white small mb-2 d-flex align-items-center justify-content-center justify-content-md-start transition-all">
                <i class="fas fa-map-marker-alt me-2 text-primary-pink"></i>
                Milano, Via Mauro Macchi 8, 20123
              </a>
              <a href="https://www.instagram.com/dopt_finanza/" target="_blank" rel="noopener noreferrer" class="text-decoration-none text-white small mb-0 d-flex align-items-center justify-content-center justify-content-md-start transition-all">
                <i class="fab fa-instagram me-2 text-primary-pink"></i>
                @dopt_finanza
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer Bottom -->
  <div class="footer-bottom bg-black py-3" style="border-top: 1px solid #333;">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 text-center text-md-start mb-2 mb-md-0">
          <p class="text-white small mb-0">
            &copy; {{ currentYear }} DOPT. P.iva 12081790961. Tutti i diritti riservati.
          </p>
        </div>
        <div class="col-md-6 text-center text-md-end">
          <a href="https://www.iubenda.com/privacy-policy/16220753" target="_blank" rel="noopener noreferrer" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe footer-legal-link text-decoration-none text-white small fw-medium transition-all" title="Privacy Policy ">Privacy Policy</a>
          <span class="separator text-white mx-2">|</span>
          <a href="https://www.iubenda.com/privacy-policy/16220753/cookie-policy" target="_blank" rel="noopener noreferrer" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe footer-legal-link text-decoration-none text-white small fw-medium transition-all" title="Cookie Policy ">Cookie Policy</a>
        </div>
      </div>
    </div>
  </div>
</footer>

